"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnrichPath = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useEnrichPath = () => {
    const { config: { enrichPath } } = (0, react_1.useContext)(context_1.EnrichContext);
    return enrichPath;
};
exports.useEnrichPath = useEnrichPath;
exports.default = exports.useEnrichPath;
